import { PropsWithChildren, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { client } from '@antimatterhq/asl-api-ts-v1';
import { useConfig } from '@/contexts/ConfigContext';

const queryClient = new QueryClient();

export const TanStackQueryClientProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { API_URL } = useConfig();

  useEffect(() => {
    client.setConfig({
      baseURL: API_URL,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
